import { AfterViewInit, ChangeDetectionStrategy, Component, Input, computed, signal } from '@angular/core';
import { ContentBlock } from '../../models';
import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { PlaySlideItem } from '../../models/playSlideItem.model';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';

@Component({
  selector: 'app-content-block-play-slide',
  templateUrl: './content-block-play-slide.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockPlaySlideComponent extends ContentBlockBaseComponent implements AfterViewInit {
  @Input() activeScrollTrigger: string[] = [];

  sectionTheme(i: number) {
    const themesInOrder = ['dark', 'primary', 'dark-2', 'sand'];
    return themesInOrder[i % themesInOrder.length];
  }

  id(item: PlaySlideItem) {
    return 'play-slide-' + item.id;
  }

  override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.initScrollTrigger('.theme--sand', 'light');
  }
}
